export default "__VITE_ASSET__DECw6GIh__"